var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "partner-link__wrapper" },
    [
      _c(
        "button-control",
        {
          staticClass: "_yellow",
          attrs: { "is-block": true, size: "small" },
          on: { click: _vm.openModal }
        },
        [
          _c("icon", {
            staticClass: "partner-link__icon",
            attrs: { name: "Link_24", width: 24, height: 24 }
          }),
          _vm._v("\n    Партнерская ссылка\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "PartnerLinkModal" } },
        [_c("partner-link-modal")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }